<ion-header translucent="true">
  <ion-toolbar class="toolbar">
    <ion-buttons slot="start">
      <ion-back-button *ngIf="back" [defaultHref]="defaultHref" text="Terug"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button *ngIf="editLink" class="edit-text" (click)="edit()">Bewerk</ion-button>
      <ion-menu-toggle>
        <ion-button>
          <img src='/assets/images/menu-right-icon.png' style="width: 20px; margin-left: 9px;">
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>
    <ion-title class="ion-text" (click)="invalidateCache()">{{title}}</ion-title>
    <ng-content></ng-content>
  </ion-toolbar>
</ion-header>
